import { useEffect, useState } from 'react'
import { Etichetta } from '../../componenti/base.tsx'
import * as posta from '../../servizi/posta.ts'
import { etichettaProvenienza, type DatiProvenienza } from '../../servizi/regole-provenienza.ts'
import '../../stile-posta-caselle.css'

/**
 * «CIDIS», «esterno», «falso CIDIS?» accanto al mittente di ogni messaggio (2/11/2026): nella
 * conversazione, aperto o chiuso, e nell'archivio delle caselle. Le regole stanno in
 * servizi/regole-provenienza.ts; il titolo dice su che cosa si basa l'etichetta.
 */

function useDominiCidis(): string[] | null {
  const [domini, setDomini] = useState<string[] | null>(null)
  useEffect(() => {
    let vivo = true
    posta.leggiDominiCidis().then((d) => { if (vivo) setDomini(d) }, () => undefined)
    return () => { vivo = false }
  }, [])
  return domini
}

export function EtichettaProvenienza({ messaggio }: { messaggio: DatiProvenienza }) {
  const e = etichettaProvenienza(messaggio, useDominiCidis())
  if (!e) return null
  return (
    <span className="posta-etichetta-provenienza" title={e.titolo}>
      <Etichetta tono={e.tono}>{e.testo}</Etichetta>
    </span>
  )
}
